var render = function render() {
  var _vm$node, _vm$activeNode, _vm$node$attributes$d
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "studip-tree-node",
    },
    [
      _c(
        "span",
        {
          class: {
            "studip-tree-node-content": true,
            "studip-tree-node-active":
              ((_vm$node = _vm.node) === null || _vm$node === void 0
                ? void 0
                : _vm$node.id) ===
              ((_vm$activeNode = _vm.activeNode) === null ||
              _vm$activeNode === void 0
                ? void 0
                : _vm$activeNode.id),
          },
        },
        [
          _c(
            "a",
            {
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.toggleNode(true)
                },
              },
            },
            [
              _vm.node.attributes["has-children"]
                ? _c(
                    "div",
                    {
                      staticClass: "studip-tree-node-toggle",
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: _vm.openState ? "arr_1down" : "arr_1right",
                          size: 20,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.isAssignable && _vm.node.attributes.id !== "root"
            ? _c(
                "button",
                {
                  staticClass: "studip-tree-node-assignment-state",
                  attrs: {
                    title: _vm.$gettext("Zuordnung ändern"),
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.changeAssignmentState()
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape:
                        _vm.assignmentState === 0
                          ? "checkbox-unchecked"
                          : _vm.assignmentState === 1
                          ? "checkbox-checked"
                          : "checkbox-indeterminate",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.toggleNode(true)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "studip-tree-node-name",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.node.attributes.name) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.withInfo &&
          !_vm.isLoading &&
          ((_vm$node$attributes$d = _vm.node.attributes.description) === null ||
          _vm$node$attributes$d === void 0
            ? void 0
            : _vm$node$attributes$d.trim()) !== ""
            ? _c("studip-tooltip-icon", {
                attrs: {
                  text: _vm.node.attributes["description-formatted"].trim(),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isAssignable && _vm.node.attributes.id !== "root"
            ? _c("input", {
                attrs: {
                  type: "hidden",
                  name: _vm.assignmentAction,
                },
                domProps: {
                  value: _vm.node.attributes.id,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.editable && _vm.node.attributes.id !== "root"
            ? _c(
                "a",
                {
                  staticClass: "studip-tree-node-edit-link",
                  attrs: {
                    href: _vm.editUrl + "/" + _vm.node.attributes.id,
                    "data-dialog": "size=medium",
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.editNode(_vm.editUrl, _vm.node.id)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "edit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "studip-spinner",
            },
            [
              _c("studip-asset-img", {
                attrs: {
                  file: "ajax-indicator-black.svg",
                  width: "20",
                },
              }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$gettext("Daten werden geladen...")) +
                  "\n    "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.node.attributes["has-children"] && _vm.openState
        ? _c(
            "ul",
            {
              staticClass: "studip-tree-children",
            },
            _vm._l(_vm.children, function (child) {
              return _c(
                "li",
                {
                  key: child.id,
                },
                [
                  _c("studip-tree-node", {
                    attrs: {
                      node: child,
                      editable: _vm.editable,
                      "edit-url": _vm.editUrl,
                      "create-url": _vm.createUrl,
                      "delete-url": _vm.deleteUrl,
                      assignable: _vm.assignable,
                      ancestors: _vm.theAncestors,
                      "not-assignable-nodes": _vm.notAssignableNodes,
                      "open-nodes": _vm.openNodes,
                      "open-levels":
                        _vm.openLevels > 0 ? _vm.openLevels - 1 : 0,
                      "visible-children-only": _vm.visibleChildrenOnly,
                      "active-node": _vm.activeNode,
                      "with-info": _vm.withInfo,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }